import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { AdsApiResponse, DeleteAdsResult } from './types';
import { ADS_QUERY_KEY } from './useGetAds';

/** 1..N id — usunięcie pojedyncze to tablica jednoelementowa. */
type MutationParams = { ids: string[] };

/**
 * Kasuje reklamy z katalogu — znikają wszystkim hotelom naraz.
 * Single i bulk tym samym endpointem — body przy DELETE leci przez `config.data`.
 */
export const useDeleteAd = (
  options?: UseMutationOptions<DeleteAdsResult, AxiosError, MutationParams>,
): UseMutationResult<DeleteAdsResult, AxiosError, MutationParams> => {
  const queryClient = useQueryClient();

  return useMutation<DeleteAdsResult, AxiosError, MutationParams>({
    mutationFn: async ({ ids }) => {
      const res = await axiosInstance.delete<AdsApiResponse<DeleteAdsResult>>('/v3-deleteAds', {
        data: { ids },
      });
      return res.data.data;
    },
    ...options,
    onSuccess: (...args) => {
      queryClient.invalidateQueries({ queryKey: ADS_QUERY_KEY });
      options?.onSuccess?.(...args);
    },
  });
};
